export default "__VITE_ASSET__1CFa86Ge__"